import {filter, isArray, isEmpty, isObject, isString} from "underscore";
import dayjs from "dayjs";
import {conditionFieldTypeDisplay} from "../../pages/Schema/SchemaHelpers";
import {escapeRegExp} from "../../resources/utils/stringUtils";

const isExcluded = (field) =>
  ["__typename", "backgroundColor", "foregroundColor", "s3Key"].includes(field);

export const searchRow = (row, searchRegex, depth) => {
  if (depth > 3) {
    return false;
  }
  return Object.keys(row).some((field) => {
    if (isObject(row[field])) {
      return searchRow(row[field], searchRegex, depth + 1);
    }
    if (depth === 0) {
      if (field === "isEnabled") {
        return searchRegex.test(row[field] ? "enabled" : "disabled");
      }
      if (field === "isDisabled") {
        return searchRegex.test(row[field] ? "disabled" : "enabled");
      }
      if (field === "createdAt" || field === "updatedAt") {
        const dateField = dayjs(row[field]);
        if (dateField.isValid()) {
          return searchRegex.test(dateField.format("LLLL"));
        }
      }
      if (field === "fieldType") {
        return searchRegex.test(conditionFieldTypeDisplay(row[field]));
      }
    }
    if (!isExcluded(field) && isString(row[field])) {
      return searchRegex.test(row[field]);
    }
  });
};

export const filterRowsBySearch = (rows, searchText) => {
  if (isEmpty(rows) || isEmpty(searchText)) {
    return rows;
  }
  const searchRegex = new RegExp(escapeRegExp(searchText), "i");
  return filter(rows, (row) => searchRow(row, searchRegex, 0));
};

export const getDefaultTableSort = (sortModel) => {
  if (isArray(sortModel)) {
    return sortModel;
  }
  if (sortModel) {
    return [sortModel];
  }
  return [];
};
